import { Button, ValuePropositionLayout } from '@hg/stylizator/components'
import { Text } from '@hg/stylizator/typography'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { IWPGBlockAttributesCompare } from 'app/helpers/IWPGBlockAttributesCompare'

interface IAttributes {
  bodyText: string
  buttonText: string
  buttonUrl: string
  headingText: string
  illustration?: string
  illustrationAlt?: string
  buttonType?: 'primary' | 'secondary'
  className?: string
}

const ValuePropositionBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <ValuePropositionLayout
      body={attributes.bodyText}
      button={
        attributes.buttonText ? (
          <Button
            className={attributes.className}
            type={attributes?.buttonType || 'secondary'}
            onClick={() => (window.location.href = attributes.buttonUrl)}
          >
            {attributes.buttonText}
          </Button>
        ) : undefined
      }
      heading={
        <Text type="heading_large" useCompact spacingType="between_title_and_text">
          <h2>{attributes.headingText}</h2>
        </Text>
      }
      illustration={<LazyLoadImage src={attributes.illustration} alt={attributes.illustrationAlt} />}
    />
  )
}

export default React.memo(ValuePropositionBlock, IWPGBlockAttributesCompare)
